import { useEffect, useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { defaultStatuses } from "../../stores/PrmStore";
import { Select } from "@mantine/core";
import { useLeadsStore } from "../../stores/LeadsStore";
import { useProfileStore } from "../../stores/UserStore";

const PRMStatusSelector = ({
  value,
  onChange,
  noLabel,
  label,
  required,
  disabled,
  isUser,
  id,
  w,
  defaultOptions,
  name,
  withinPortal = false,
  size,
}) => {
  const systemStatuses = useLeadsStore((s) => s.systemStatuses);
  const customStatuses = useLeadsStore((s) => s.customStatuses);
  const lang = useLanguage((s) => s.language);

  const [options, setOptions] = useState(
    defaultOptions ||
      defaultStatuses().map((x) => ({ label: x.name, value: x.id }))
  );

  useEffect(() => {
    if (!defaultOptions) {
      setOptions(
        [...systemStatuses, ...customStatuses].map((status) => ({
          value: status.id?.toString(),
          label: `${status.name}${
            useProfileStore.getState().unswitchedProfile?.id === 11 ? ` #${status.id}` : ""
          }`,
          isCustom: true,
          sorting: status.sorting,
        }))
      );
    }
  }, [customStatuses, defaultOptions, isUser, systemStatuses]);

  return (
    <Select
      id={id}
      label={
        noLabel ? null : label || lang.components.status_selector.default_label
      }
      placeholder={lang.components.status_selector.default_label}
      required={required}
      onChange={onChange}
      disabled={disabled}
      value={value}
      w={w}
      size={size}
      name={name}
      clearable={!required}
      data={options
        .filter((x) => !x.disabled)
        .map((x) => ({
          ...x,
        }))
        .sort((a, b) => a?.sorting - b?.sorting)}
      comboboxProps={{
        zIndex: 1600,
        withinPortal,
      }}
      aria-required
      searchable
    />
  );
};

export default PRMStatusSelector;
